module.exports = __webpack_public_path__ + "static/media/Cognition.b216f25a.svg";